
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Phone, ArrowRight } from 'lucide-react';

const BrokerageHero = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <section className="pt-20 pb-16 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden section-float">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-32 h-32 border border-nexx-green rounded-full"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-nexx-green rounded-full"></div>
        <div className="absolute bottom-20 left-1/3 w-16 h-16 border border-nexx-green rounded-full"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          <Badge className="mb-6 bg-nexx-green/10 text-nexx-green border-nexx-green/20">
            Connectivity Brokerage, Done Right
          </Badge>
          
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            We Don't Just Broker Connections—
            <span className="text-nexx-green"> We Engineer Outcomes</span>
          </h1>
          
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Because we're not just middlemen—we're the team building your infrastructure.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-nexx-green hover:bg-green-700 text-white px-8 py-4 text-lg group"
              asChild
            >
              <a href="tel:+12402198426" className="flex items-center gap-2">
                <Phone className="h-5 w-5" />
                Talk to a Real Advisor
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </a>
            </Button>
            
            <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
              <DialogTrigger asChild>
                <Button 
                  size="lg" 
                  variant="outline" 
                  className="border-nexx-green text-nexx-green hover:bg-nexx-green hover:text-white px-8 py-4 text-lg"
                >
                  Get a Custom Quote
                </Button>
              </DialogTrigger>
              <DialogContent className="max-w-4xl w-[95vw] max-h-[90vh] p-0 overflow-hidden">
                <DialogTitle className="sr-only">Get Custom Quote</DialogTitle>
                <DialogDescription className="sr-only">
                  Fill out this form to get a custom quote for your connectivity needs
                </DialogDescription>
                <div className="w-full h-[85vh] p-4">
                  <h3 className="text-2xl font-bold text-center mb-4 text-gray-900">
                    Let's Connect You With Our Business Team
                  </h3>
                  <iframe 
                    src="https://tally.so/embed/3NQKvW?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
                    loading="lazy" 
                    width="100%" 
                    height="100%"
                    style={{ border: 'none', borderRadius: '8px' }}
                    title="Custom Quote Request"
                    className="w-full h-full rounded-lg"
                  />
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrokerageHero;
